// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eula .box {
  margin-bottom: unset;
}

.eula ul {
  list-style-type: disc;
  list-style-position: inside;
}

.eula ol {
  counter-reset: item;
  list-style-type: decimal;
  list-style-position: inside;
}

.eula ol li {
  counter-increment: item;
  padding-bottom: var(--base-sizes-2);
}

.eula ol ol li {
  display: block;
}

.eula ol ol li:before {
  content: counters(item, ".") ". ";
}

.eula ol ol ol li:before {
  margin-right: var(--base-sizes-1);
}

.eula ol.lower-roman {
  counter-reset: roman;
  list-style-type: none;
}

.eula ol.lower-roman li {
  counter-increment: roman;
  padding-bottom: var(--base-sizes-2);
}

.eula ol.lower-roman li:before {
  content: "(" counter(roman, lower-roman) ") ";
}

.eula ol ol ol.lower-roman li:before {
  margin-left: auto;
  margin-right: auto;
}

.eula table {
  margin-top: var(--base-sizes-2);
}

.eula table caption {
  caption-side: bottom;
  text-align: center;
  --tw-text-opacity: 1;
  color: rgb(var(--base-colors-black-black100) / var(--tw-text-opacity));
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/pages/Auth/Eula/Eula.css","webpack://./services/frontend/app/pages/Auth/Eula/Eula.css"],"names":[],"mappings":"AADA;ECEE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,sEAAsE;AACxE","sourcesContent":[".eula .box {\n    margin-bottom: unset;\n  }\n  .eula ul {\n    list-style-position: inside;\n    list-style-type: disc;\n}\n  .eula ol {\n    list-style-position: inside;\n    list-style-type: decimal;\n\n    counter-reset: item;\n}\n  .eula ol li {\n    counter-increment: item;\n    padding-bottom: var(--base-sizes-2);\n  }\n  .eula ol ol li {\n    display: block;\n  }\n  .eula ol ol li:before {\n    content: counters(item, '.') '. ';\n  }\n  .eula ol ol ol li:before {\n    margin-right: var(--base-sizes-1);\n}\n  .eula ol.lower-roman {\n    counter-reset: roman;\n    list-style-type: none;\n  }\n  .eula ol.lower-roman li {\n    counter-increment: roman;\n    padding-bottom: var(--base-sizes-2);\n  }\n  .eula ol.lower-roman li:before {\n    content: '(' counter(roman, lower-roman) ') ';\n  }\n  .eula ol ol ol.lower-roman li:before {\n    margin-left: auto;\n    margin-right: auto;\n}\n  .eula table {\n    margin-top: var(--base-sizes-2);\n}\n  .eula table caption {\n    caption-side: bottom;\n    text-align: center;\n    --tw-text-opacity: 1;\n    color: rgb(var(--base-colors-black-black100) / var(--tw-text-opacity));\n  }\n",".eula .box {\n  margin-bottom: unset;\n}\n\n.eula ul {\n  list-style-type: disc;\n  list-style-position: inside;\n}\n\n.eula ol {\n  counter-reset: item;\n  list-style-type: decimal;\n  list-style-position: inside;\n}\n\n.eula ol li {\n  counter-increment: item;\n  padding-bottom: var(--base-sizes-2);\n}\n\n.eula ol ol li {\n  display: block;\n}\n\n.eula ol ol li:before {\n  content: counters(item, \".\") \". \";\n}\n\n.eula ol ol ol li:before {\n  margin-right: var(--base-sizes-1);\n}\n\n.eula ol.lower-roman {\n  counter-reset: roman;\n  list-style-type: none;\n}\n\n.eula ol.lower-roman li {\n  counter-increment: roman;\n  padding-bottom: var(--base-sizes-2);\n}\n\n.eula ol.lower-roman li:before {\n  content: \"(\" counter(roman, lower-roman) \") \";\n}\n\n.eula ol ol ol.lower-roman li:before {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.eula table {\n  margin-top: var(--base-sizes-2);\n}\n\n.eula table caption {\n  caption-side: bottom;\n  text-align: center;\n  --tw-text-opacity: 1;\n  color: rgb(var(--base-colors-black-black100) / var(--tw-text-opacity));\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
